// When the global fetch interceptor (src/index.js) keeps an API error out of the generic error modal.
//
// A read (GET/HEAD) answered with 4xx reports a state of what was asked for (not there, not assigned, not in
// that state), and the page shows it itself: never the modal, like a 403 read. Each such read used to get its
// own entry in the interceptor's path list (20 by 02.11.2026, the last ones for the Inbox); this ends that
// pattern. Writes keep the modal, and a 5xx shows it at most once a minute per endpoint, so a 5 s poll cannot
// reopen it on every tick.

export const REPEAT_MS = 60000;
const lastShown = new Map(); // "METHOD path status" -> when the modal last showed it

export function isModalSilent({ method, url, status, listed = false }, now = Date.now()) {
  const verb = (method || 'GET').toUpperCase();
  if (listed) return true;
  if ((verb === 'GET' || verb === 'HEAD') && status < 500) return true;
  const key = `${verb} ${String(url).split('?')[0]} ${status}`;
  const last = lastShown.get(key);
  if (last !== undefined && now - last < REPEAT_MS) return true;
  lastShown.set(key, now);
  return false;
}
